import React from 'react';

function Suporte() {

  const handleRedirect = () => {
    window.location.href = 'https://infoservicebarreiras.com.br/login.php';
  };

  return (
    <div className="container text-light py-4">
      <div
        className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3 p-4 rounded-4 mb-4"
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.7)',
          boxShadow: '0 0 20px rgba(0,0,0,0.8)'
        }}
      >
        <div className="text-center text-md-start">
          <h1
            style={{
              fontSize: '4rem',
              fontFamily: '"Bebas Neue", sans-serif',
              letterSpacing: '8px',
              color: '#fff',
              textShadow: '2px 2px 5px rgba(0,0,0,0.6)',
              marginBottom: '0'
            }}
          >
            GUB
          </h1>
          <p
            style={{
              fontSize: '1.2rem',
              fontFamily: '"Bebas Neue", sans-serif',
              textTransform: 'uppercase',
              letterSpacing: '4px',
              color: '#fff',
              textShadow: '1px 1px 3px rgba(0,0,0,0.5)'
            }}
          >
            Grupo Urbano Bessa
          </p>
        </div>

       <button
  onClick={handleRedirect}
  className="btn fw-semibold px-5 py-3 border-0"
  style={{
    background: 'linear-gradient(135deg, #0d6efd, #4f9cff)',
    color: '#fff',
    borderRadius: '14px',
    boxShadow: '0 0 18px rgba(13,110,253,0.55)',
    fontSize: '1.1rem',
    letterSpacing: '1px',
    transition: 'all 0.3s ease'
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'translateY(-2px)';
    e.currentTarget.style.boxShadow = '0 0 28px rgba(13,110,253,0.8)';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = '0 0 18px rgba(13,110,253,0.55)';
  }}
>
  Acessar Suporte
</button>

      </div>
    </div>
  );
}

export default Suporte;

